import type { FileRecord } from "@cohesive/api-client";

/** Canvas node entities often carry a stub; prefer the cached API record when available. */
export function resolveFileRecordFromList(
  record: FileRecord | null | undefined,
  allRecords: readonly FileRecord[],
): FileRecord | null {
  if (!record?.id) {
    return null;
  }
  return (
    allRecords.find((r) => r.id === record.id) ??
    // A node minted before its file was promoted to the Library still points
    // at the file's id; the canvas list now holds a link row targeting it.
    // Resolve through the link so the node keeps live data (and its badge).
    allRecords.find((r) => r.target_file_record_id === record.id) ??
    record
  );
}
